export default "__VITE_ASSET__YO6NvyAm__"